// IE 2026 10 09 / ODOO-345618 (заказ Игоря: согласование на сегменте; правило объяснений по Alt, 24.09) — КАРТА ОБЪЯСНЕНИЙ ОБЛАСТИ «APPROVAL»: подменю «Approval» командной панели таблицы, его команды,
// пилюля статуса в заголовке строки-группы и раздел APPROVAL формы ячейки. Формат записи — как у прочих областей (utils/uiHelp.js): { title, what, why, click, affects, stored, setting }.
// Тексты — английские литералы в t() (словари uk / ru — src/i18n/messages). Проверка записей — tests/unit/approval.test.mjs.
import { t } from '@/i18n'
import { PLAN_APPROVAL_DEFAULT } from '@/utils/planApproval'   // IE 2026 11 03 / ODOO-5800 (webscm #128539: ассистент показывал запись выключенной функции)

const approval = {
    'approval.menu': () => ({
        title: t('Approval'),
        what: t('Commands of the approval of the selected rows: submit for approval, approve, return, recall, reopen, skip, history; start and close a cycle; the approval monitor.'),
        why: t('The plan of a segment is approved unit by unit (for example brand → business unit → all); after the submit the data of the unit is locked.'),
        click: t('Select rows (or a group row) and pick a command; Return, Reopen and Skip ask for a comment.'),
        affects: t('Changes the status of the approval units of the selected rows; the data is locked or unlocked by the status.'),
        stored: t('Approval units and their events (immutable history) in the database'),
        setting: 'fe.ux.approval',
    }),
    'approval.cmd.submit': () => ({
        title: t('Submit'),
        what: t('Sends the approval unit of the selected rows (its data) to the approver of the step.'),
        why: t('The approver gets the unit to check; the preparer cannot change the data until it is returned.'),
        click: t('Select rows of the unit and click.'),
        affects: t('Status Draft → In review; the sums of the unit are fixed for the comparison with later changes.'),
    }),
    'approval.cmd.recall': () => ({
        title: t('Recall'),
        what: t('Takes the unit back from the approver while he has not acted yet.'),
        why: t('To fix something after the submit without waiting for a return.'),
        click: t('Select rows of the unit and click.'),
        affects: t('Status In review → Draft; the lock of the preparer is lifted.'),
    }),
    'approval.cmd.approve': () => ({
        title: t('Approve'),
        what: t('Approves the unit at its step; the last step approves the data finally.'),
        why: t('The next level can be submitted only when all units below are approved.'),
        click: t('Select rows of the unit and click.'),
        affects: t('Status In review → Approved; the data is locked for everybody; the parent unit goes to review when all its children are approved.'),
    }),
    'approval.cmd.return': () => ({
        title: t('Return'),
        what: t('Returns the unit to the preparer with a comment and a reason category.'),
        why: t('The preparer sees why and fixes the data.'),
        click: t('Select rows of the unit, click, write the comment and pick the category.'),
        affects: t('Status In review → Returned; the preparer can edit again; the units above wait.'),
    }),
    'approval.cmd.reopen': () => ({
        title: t('Reopen'),
        what: t('Opens approved data for changes again; a reason is mandatory.'),
        why: t('Approved data is locked for everybody, including administrators; this is the only way to change it.'),
        click: t('Select rows of the approved unit, click and write the reason.'),
        affects: t('Status Approved → Returned; the approved parents wait for the unit again; the history is kept.'),
    }),
    'approval.cmd.skip': () => ({
        title: t('Skip'),
        what: t('Skips an optional step of the unit with a comment.'),
        why: t('Some steps are not needed for every unit.'),
        click: t('Select rows of the unit, click and write the reason.'),
        affects: t('The step is closed without approval; the process goes on with the next step.'),
    }),
    // IE 2026 10 10 / ODOO-345618 (заказ Игоря: согласование под ключ) — FE1-uihelp FE1: Set due (администратор) и действие «від імені» (кнопки раздела APPROVAL формы ячейки)
    'approval.cmd.set_due': () => ({
        title: t('Set due…'),
        what: t('Changes the due date of the approval unit (an administrator only); an empty date removes the due date.'),
        why: t('The due of a step comes from the policy; sometimes it has to be moved for one unit.'),
        click: t('Click, pick the date and write the comment.'),
        affects: t('The due date of the unit; the status does not change; the event with the old and the new date stays in the history.'),
    }),
    // IE 2026 10 16 / ODOO-5800: кнопка по записи перехода WORKFLOW v2 (подпись — название записи «Status change reason»)
    'approval.cmd.transition': () => ({
        title: t('Status change'),
        what: t('Applies the status change reason of the WORKFLOW record: the unit goes from its current status to the status of the record.'),
        why: t('The transitions, their roles and checks are configured in the Status change reasons catalog of the segment, not hard-coded.'),
        click: t('Click; when the record requires a comment or a category, the window asks for them.'),
        affects: t('Status of the approval unit of the selected rows; the data is locked or unlocked by the new status.'),
        setting: 'fe.ux.approvalTransitions',
    }),
    'approval.cmd.onBehalf': () => ({
        title: t('on behalf'),
        what: t('You do not prepare this plan; the action will be done on behalf of the role of the step with a mandatory comment and a note in the history.'),
        why: t('An administrator can act for the role of the step when its holder cannot.'),
        click: t('Click and write the comment.'),
        affects: t('The status of the unit, as the action of the role; the history marks the event as done on behalf.'),
    }),
    'approval.cmd.history': () => ({
        title: t('History'),
        what: t('The list of events of the unit: who, when, what, the comment and the sums at that moment.'),
        why: t('To see how the plan was approved and what changed after.'),
        click: t('Select rows of the unit and click.'),
        affects: t('Nothing — reading only; the history is never changed.'),
    }),
    'approval.cmd.start_cycle': () => ({
        title: t('Start cycle'),
        what: t('Creates the approval units of the plan version by the policy of the segment.'),
        why: t('A new version of the plan starts a new approval cycle.'),
        click: t('Click; the server reports how many units were created.'),
        affects: t('New units in Draft (or Waiting for the lower level).'),
    }),
    'approval.cmd.close_cycle': () => ({
        title: t('Close cycle'),
        what: t('Closes the cycle of the version: approved data is frozen.'),
        why: t('The approved plan becomes the baseline of the next cycle.'),
        click: t('Click and confirm.'),
        affects: t('Approved units become Frozen; the data is locked for good.'),
    }),
    'approval.cmd.monitor': () => ({
        title: t('Monitor'),
        what: t('Opens the approval monitor: units by steps, statuses, overdue and «waiting for me».'),
        why: t('One place to see where each unit of the plan is stuck.'),
        click: t('Click.'),
        affects: t('Nothing — opens a list.'),
    }),
    // IE 2026 10 10 / ODOO-345618 (заказ Игоря: согласование под ключ): пункт «My approvals…» — список «Waiting for my approval» (approval-my)
    'approval.cmd.my': () => ({
        title: t('My approvals…'),
        what: t('Opens the list of the approval units that wait for your approval: the units in review where you are one of the approvers.'),
        why: t('Your inbox as an approver: what to look at first, without searching the plan.'),
        click: t('Click; the list opens as a widget of this page and is read again at every click.'),
        affects: t('Nothing — opens a list.'),
        stored: t('Approval units in the database'),
        setting: 'fe.ux.approval · fe.ux.approvalMyList',
    }),
    'approval.rowMenu': () => ({
        title: t('Approval of this row'),
        what: t('The approval commands of this row: only those the server allows you now (submit, recall, approve, return, reopen, skip, history); the ones marked «on behalf» are for an administrator and need a comment.'),
        why: t('The same commands as in the Approval menu of the table, but over the approval unit of this very row — no selection needed.'),
        click: t('Pick a command; Return, Reopen and Skip (and every command on behalf) ask for a comment.'),
        affects: t('Changes the status of the approval unit of this row; the data is locked or unlocked by the status.'),
        stored: t('Approval units and their events (immutable history) in the database'),
        setting: 'fe.ux.approval',
    }),
    'approval.history': () => ({
        title: t('History'),
        what: t('The events of the approval unit, newest first: when, who (and in which role, or on behalf of it), the action, the status before and after, the comment and the category, the change of the sums.'),
        why: t('To see how the plan was approved, who returned it and why, and what changed after the approval.'),
        click: t('Pick a unit tab (when several units were asked); Esc or Close closes the window.'),
        affects: t('Nothing — reading only; the history is never changed.'),
        stored: t('Approval events in the database'),
        setting: 'fe.ux.approval',
    }),
    'approval.mark.pill': () => ({
        title: t('Approval status'),
        what: t('The status of the approval unit this row belongs to; for a parent row — how many child units are approved.'),
        why: t('Shows at a glance what is waiting for whom; the data of locked units cannot be edited.'),
        click: t('Select the row and use the Approval menu of the table; the cell form shows the whole chain.'),
        affects: t('Nothing — the status is set by the approval commands.'),
        stored: t('Approval units in the database'),
        setting: 'fe.ux.approval',
    }),
    'approval.cellForm': () => ({
        title: t('Approval of the cell'),
        what: t('The approval chain of the unit this cell belongs to: the steps, who acted, whom the step waits for; who changed the data of the cell and when (before the submit, after the submit, after the approval); the sums.'),
        why: t('A full answer to «is this number approved, and what changed after».'),
        click: t('Collapse / expand by the header; the buttons act on the unit of this cell, at the step they are shown at.'),
        affects: t('The buttons change the status of this one unit; nothing else.'),
        stored: t('Collapsed state — in this browser; the approval itself — in the database'),
        setting: 'fe.ux.approval · fe.cellForm.approval (auto / always / off)',
    }),
    // IE 2026 11 03 / ODOO-5800 (заказ Игоря 30.10 «по рекомендациям»: утверждение планов из Баланса, этап B): кнопка «Plan approval» шапки Баланса, пилюля строки плана ЗП / DO, раздел PLAN DECISION формы ячейки (utils/planApproval)
    'planApproval.menu': (vars) => ({   // IE 2026 11 03 / ODOO-5800 (заказ Игоря 03.11: «Сделай более лаконичный заголовок или иконку. Для формы меню утверждения»): now — состояние видов плана (кнопка без текста чипов)
        title: t('Plan approval'),
        now: (vars && vars.summary) || '',
        what: t('The state of the purchase and transfer plans of the positions in the report; the colour is the worst state. The menu approves the plan, marks it processed until a date, confirms it after an autoplan change, withdraws the approval and shows the history.'),
        why: t('The planner reviews the autoplan right in the Balance: fixed months are not overwritten by the autoplan.'),
        click: t('Pick a command of a plan kind; the list of plan positions is shown for confirmation first.'),
        affects: t('Fixes or releases the rows of the plan segment and writes an approval event.'),
        stored: t('Plan segment rows and approval events in the database'),
        setting: 'fe.ux.planApproval',
        settingDefault: PLAN_APPROVAL_DEFAULT,   // IE 2026 11 03 / ODOO-5800 (webscm #128539: ассистент показывал запись выключенной функции): дефолт флага ВЫКЛ — при невключённом флаге ассистент запись не предлагает
    }),
    'planApproval.pill': () => ({
        title: t('Plan decision'),
        what: t('The decision on the plan of this row: processed until a date, approved, changed after the approval or withdrawn; the lock means the months are fixed.'),
        why: t('Shows which plan numbers the autoplan no longer overwrites.'),
        click: t('Open the cell form of the plan row to change the decision.'),
        affects: t('Nothing — the state is set by the decision.'),
        stored: t('Plan segment rows in the database'),
        setting: 'fe.ux.planApproval',
        settingDefault: PLAN_APPROVAL_DEFAULT,   // IE 2026 11 03 / ODOO-5800 (webscm #128539: ассистент показывал запись выключенной функции): дефолт флага ВЫКЛ — при невключённом флаге ассистент запись не предлагает
    }),
    'planApproval.cellForm': () => ({
        title: t('Plan decision'),
        what: t('The decision on the plan position of the cell: approve the whole horizon, processed until a date (with a reason and a comment) or withdraw; below — the history of the decisions.'),
        why: t('Up to the decision date the plan is fixed, after it the autoplan stays live.'),
        click: t('Choose the decision, fill in the required fields and save; the list of plan positions is shown for confirmation first.'),
        affects: t('Fixes or releases the rows of the plan segment and writes an approval event.'),
        stored: t('Plan segment rows and approval events in the database'),
        setting: 'fe.ux.planApproval',
        settingDefault: PLAN_APPROVAL_DEFAULT,   // IE 2026 11 03 / ODOO-5800 (webscm #128539: ассистент показывал запись выключенной функции): дефолт флага ВЫКЛ — при невключённом флаге ассистент запись не предлагает
    }),
}
export default approval
